"use client";
import * as React from "react";
import { IEvent } from "@/types/event";
import { EventMediumCard } from "../card/eventMediumCard";

// const endpoint = `https://graphql.contentful.com/content/v1/spaces/${process.env.NEXT_PUBLIC_CF_SPACE_ID}`;
// const client = new GraphQLClient(endpoint, {
//   headers: {
//     "Content-Type": "application/json",
//     Authorization: `Bearer ${process.env.NEXT_PUBLIC_CF_PREVIEW_ACCESS_TOKEN}`,
//   },
// });

export const EventsList = ({
  entries,
  totalEntriesNumber: initialTotalEntriesNumber,
}: {
  entries: IEvent[];
  totalEntriesNumber: number;
}) => {
  const displayEntries = entries;

  return (
    <>
      <h1 id="page-title" className="text-3xl font-medium text-brand-blue">
        Évènement{displayEntries.length > 1 ? "s" : ""}{" "}
        <span className="hidden text-brand-brown opacity-40">
          ({initialTotalEntriesNumber})
        </span>
      </h1>
      <div className="space-y-6 xl:space-y-8">
        {displayEntries?.map((entry: IEvent, index: number) => (
          <React.Fragment key={entry?.sys?.id}>
            <EventMediumCard entry={entry} />
            {index + 1 < entries.length && <hr />}
          </React.Fragment>
        ))}
      </div>
    </>
  );
};
